import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CoreModule } from '@core/core.module';
import { environment } from '@environments/environment';
import { TranslationUtilsModule } from '@myscania/translation-utils-angular';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NoInternetToastrComponent } from '@shared/components/no-internet-toastr/no-internet-toastr.component';
import { NoNetworkComponent } from '@shared/components/no-network/no-network.component';
import { TooltipOutletComponent } from '@shared/components/tooltip/tooltip-outlet.component';
import { ModalOutletComponent } from '@shared/services/modal/modal.service';
import { SharedModule } from '@shared/shared.module';
import { ToastModule } from '@teamsp/components/toast';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent, NoInternetToastrComponent, NoNetworkComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    CoreModule.forRoot(environment),
    EffectsModule.forRoot([]),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: false }),
    SharedModule,
    ModalOutletComponent,
    TooltipOutletComponent,
    StoreModule.forRoot({}, {}),
    TranslationUtilsModule,
    ToastModule.forRoot({ position: 'bottom-right', duration: 3000, closable: true, edgeMargin: '1.6rem' })
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
  exports: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
